import axios from 'axios';
import { B2BLead, Lead } from '../dtos/lead';
import { getApiV1Url, getApiV2Url } from '../utils/api';

export async function createEvaluationLeadV2(evaluationLead: Lead): Promise<Lead> {
  const { data } = await axios.post<Lead>(`${getApiV2Url()}/leads`, evaluationLead);

  return data;
}

export async function createB2BLead(lead: B2BLead): Promise<B2BLead> {
  const { data } = await axios.post<B2BLead>(`${getApiV1Url()}/b2b-leads`, lead);

  return data;
}
